import { render, staticRenderFns } from "./PanelNotLogin.vue?vue&type=template&id=2bd61f14&scoped=true&"
import script from "./PanelNotLogin.vue?vue&type=script&lang=js&"
export * from "./PanelNotLogin.vue?vue&type=script&lang=js&"
import style0 from "./PanelNotLogin.vue?vue&type=style&index=0&id=2bd61f14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd61f14",
  null
  
)

export default component.exports